import React from 'react';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-fetching-library';
import { Box, Stack, Button, InputLabel, MenuItem, FormControl, Select, Typography } from '@mui/material';
import { updatePaymentAction } from '../../../../../../services/request';
import { updateOrder } from '../../../../../../services/redux-actions';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import { CreatePayment, getRodzajPlatnosciString } from './CreatePayment';

const AddPaymentModal = ({ order, handleClose, handleOpenSnackbar = () => {}, updateOrderList = () => {} }) => {
  const dispatch = useDispatch();
  const [paymentId, setPaymentId] = React.useState('');
  const [openAddPayment, setOpenAddPayment] = React.useState(false);
  const { mutate } = useMutation(updatePaymentAction);

  const handleSelectChange = e => setPaymentId(e.target.value);

  const formik = useFormik({
    initialValues: {
      paid: true,
      payment_type: 3,
      status: 5
    },
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  const handleSubmit = async values => {
    const { error, payload } = await mutate(paymentId, values);

    if (!error) {
      const updatedOrder = { ...order, order_payments: order.order_payments.map(payment => payment.id !== payload.id ? payment : payload) };
      dispatch(updateOrder(updatedOrder));
      updateOrderList(updatedOrder);
      handleOpenSnackbar('success', 'Płatność została dodana');
      handleClose();
    }
  };

  const payments = order.order_payments.filter(payment => !payment.paid && !payment.deleted);

  if (openAddPayment) {
    return <CreatePayment order={order} handleClose={() => setOpenAddPayment(false)} updateOrderList={updateOrderList}/>;
  }

  if (payments.length === 0) {
    return (
      <Box>
        <Stack alignItems="center">
          <PriceCheckIcon color="success" sx={{ fontSize: '100px' }} />
          <Box height={20} />
          <Typography variant="h4">Wszystko zostało opłacone</Typography>
          <Box height={40} />
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Button variant="outlined" style={{ flex: '0.45' }} onClick={() => setOpenAddPayment(true)}>Dodaj opłate</Button>
          <Button variant="contained" style={{ flex: '0.45' }} onClick={handleClose}>Zamknij</Button>
        </Stack>
      </Box>
    );
  }

  return (
    <>
      <Button variant="text" fullWidth onClick={() => setOpenAddPayment(true)}>Dodaj opłate</Button>
      <Box height={20} />
      <form onSubmit={formik.handleSubmit}>
        <Stack spacing={4}>
          <FormControl>
            <InputLabel id="payment-label">Opłata</InputLabel>
            <Select
              labelId="payment-label"
              label="Opłata"
              value={paymentId}
              onChange={handleSelectChange}
            >
              {payments.map(payment => (
                <MenuItem key={payment.id} value={payment.id}>
                  <Typography style={{ whiteSpace: 'normal' }}>
                    <b>{getRodzajPlatnosciString(payment)}</b>{payment.to_pay}zł | {payment.title}
                  </Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel id="payment_type-label">Rodzaj płatności</InputLabel>
            <Select
              id="payment_type"
              name="payment_type"
              labelId="payment_type-label"
              label="Rodzaj płatności"
              value={formik.values.payment_type}
              onChange={formik.handleChange}
            >
              <MenuItem value={2}>Przelew bankowy</MenuItem>
              <MenuItem value={3}>Gotówka</MenuItem>
            </Select>
          </FormControl>
        </Stack>
        <Box height={40} />
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Button variant="outlined" style={{ flex: '0.45' }} onClick={handleClose}>Anuluj</Button>
          <Button variant="contained" style={{ flex: '0.45' }} onClick={handleSubmit} type="submit" disabled={paymentId === 0}>Dodaj płatność</Button>
        </Stack>
      </form>
    </>
  );
};


export default AddPaymentModal;
